import Label from "../../../../components/label/label";
import Input from "../../../../components/input/input";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from "react";
import { useCustomerContext } from "../../../../utils/customerContext";
import CustomSelect from "../../../../components/customSelect/customSelect";

function CreateInvoiceDetails({ onDetailsChange }) {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerSearchTerm, setCustomerSearchTerm] = useState('');
    const [actionDate, setActionDate] = useState(new Date());
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [tax, setTax] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [isPaid, setIsPaid] = useState(false);
    const [isDateRange, setIsDateRange] = useState(false);
    const [actionDateTo, setActionDateTo] = useState(null);
    
    const { fetchCustomers, customers, handleLoadMoreCustomers, customerHasMore, loading } = useCustomerContext();

    const customerItems = customers.map(c => ({
        _id: c._id, 
        name: `${c.prename || ''} ${c.name || ''}`.trim(),
        customerNumber: c.customerNumber
    }));
    const paidItems = [{id: 'true', name: 'Ja'}, {id: 'false', name: 'Nein'}];
    const paymentItems = [{id: 'Barzahlung', name: 'Barzahlung'}, {id: 'Überweisung', name: 'Überweisung'}, {id: 'Kreditkarte', name: 'Kreditkarte'}, {id: 'Paypal', name: 'Paypal'}, {id: 'Sonstige', name: 'Sonstige'}];

    const [selectedPaid, setSelectedPaid] = useState(paidItems[1]); // default Nein
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [customPaymentMethod, setCustomPaymentMethod] = useState('');

    useEffect(() => {
        fetchCustomers(true, null, '');
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            fetchCustomers(true, null, customerSearchTerm);
        }, 500);
        return () => clearTimeout(timer);
    }, [customerSearchTerm, fetchCustomers]);

    useEffect(() => {
        onDetailsChange({ selectedCustomer, actionDate, actionDateTo, invoiceDate, tax, paymentMethod, isPaid });
    }, [selectedCustomer, actionDate, actionDateTo, invoiceDate, tax, paymentMethod, isPaid]);
    
    return ( 
        <div className="createInvoiceDetailsContainer">
            <h2>Kunden- & Rechnungsdetails</h2>
            <p className="containerText">
                Bevor du eine Rechnung erstellst, stelle sicher, dass du in deinem
                Profil die nötigen Daten einträgst.
            </p>
            <CustomSelect
                items={customerItems}
                selected={selectedCustomer}
                setSelected={setSelectedCustomer}
                placeholder="Kunden auswählen"
                search={true}
                idKey="_id"
                searchTerm={customerSearchTerm}
                onSearchChange={setCustomerSearchTerm}
                onLoadMore={handleLoadMoreCustomers}
                hasMore={customerHasMore}
                loading={loading}
            />

            <div style={{display: 'flex', flexDirection: 'column', gap: '10px', width: '100%'}}>
                <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                    <Label labelValue='Leistungsdatum' />
                    <button
                        type="button"
                        onClick={() => {
                            setIsDateRange(!isDateRange);
                            setActionDateTo(null);
                        }}
                        style={{ fontSize: '12px', cursor: 'pointer' }}
                    >
                        {isDateRange ? '→ Einzeldatum' : '→ Zeitraum'}
                    </button>
                </div>

                {!isDateRange ? (
                    <DatePicker
                        selected={actionDate}
                        onChange={date => setActionDate(date)}
                        dateFormat="MMMM d, yyyy"
                        todayButton="Heute"
                        className='datepickerInput'
                    />
                ) : (
                    <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                        <DatePicker
                            selected={actionDate}
                            onChange={date => setActionDate(date)}
                            dateFormat="MMMM d, yyyy"
                            todayButton="Heute"
                            className='datepickerInput'
                            selectsStart
                            startDate={actionDate}
                            endDate={actionDateTo}
                        />
                        <span>bis</span>
                        <DatePicker
                            selected={actionDateTo}
                            onChange={date => setActionDateTo(date)}
                            dateFormat="MMMM d, yyyy"
                            className='datepickerInput'
                            selectsEnd
                            startDate={actionDate}
                            endDate={actionDateTo}
                            minDate={actionDate}
                        />
                    </div>
                )}

                <Label labelValue='Rechnungsdatum ' />
                <DatePicker
                    selected={invoiceDate}
                    onChange={date => setInvoiceDate(date)}
                    dateFormat="MMMM d, yyyy"
                    todayButton="Heute"
                    className='datepickerInput'
                />

                <Label labelFor='tax' labelValue='USt.: ' />
                <Input inputId='tax' inputName='tax' inputType='number' width="100px" borderColor='black' inputValue={tax} onChange={(e) => setTax(e.target.value)} />
                
                <Label labelValue='Ist die Rechnung schon bezahlt worden?' />
                <CustomSelect
                    items={paidItems}
                    selected={selectedPaid}
                    setSelected={(item) => {
                        setIsPaid(item.id === 'true');
                        setSelectedPaid(item);
                    }}
                    placeholder="Hier auswählen"
                    search={false}
                />

                {isPaid && (
                    <>
                        <Label labelValue='Wie wurde bezahlt?' />
                        <CustomSelect
                            items={paymentItems}
                            selected={selectedPayment}
                            setSelected={(item) => {
                                setSelectedPayment(item);
                                if (item?.id === 'Sonstige') {
                                    setPaymentMethod(customPaymentMethod);
                                } else {
                                    setPaymentMethod(item?.id || '');
                                    setCustomPaymentMethod('');
                                }
                            }}
                            placeholder="Hier auswählen"
                            search={false}
                        />

                        {selectedPayment?.id === 'Sonstige' && (
                            <>
                                <Label labelFor='customPaymentMethod' labelValue='Andere Zahlungsmethode' />
                                <Input
                                    inputId='customPaymentMethod'
                                    inputName='customPaymentMethod'
                                    inputType='text'
                                    width='100%'
                                    borderColor='black'
                                    inputValue={customPaymentMethod}
                                    onChange={(e) => {
                                        setCustomPaymentMethod(e.target.value);
                                        setPaymentMethod(e.target.value);
                                    }}
                                    placeholder='Zahlungsmethode eingeben'
                                />
                            </>
                        )}
                    </>
                )}
                {!isPaid && (
                    <p>
                        Der Gesamtbetrag ist innerhalb einer Woche nach Erhalt der Rechnung zu begleichen.
                    </p>
                )}
            </div>
        </div>
  );
}

export default CreateInvoiceDetails;